export const dummyProducts = [
	{
		"postTitle": { "titleText": "Luxury Sofa in Italian Leather" },
		"postId": { "id": 101 },
		"postDate": { "date": "12/05/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 123 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/PsCPp7Hd/sofa-4.png" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Experience unmatched comfort with this handcrafted Italian leather luxury sofa, built to impress and last..." }
	},
	{
		"postTitle": { "titleText": "Modern Velvet Sectional Sofa" },
		"postId": { "id": 102 },
		"postDate": { "date": "12/05/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 87 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/xqmSrLQy/sofa-3.png" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "A chic and spacious velvet sectional designed for both elegance and everyday relaxation..." }
	},
	{
		"postTitle": { "titleText": "Contemporary L-Shaped Sofa" },
		"postId": { "id": 103 },
		"postDate": { "date": "12/05/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 142 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/k2XqG8cf/sofa-1.png" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Transform your living space with this contemporary L-shaped sofa, combining comfort and sleek style..." }
	},
	{
		"postTitle": { "titleText": "Scandinavian Minimalist Sofa" },
		"postId": { "id": 104 },
		"postDate": { "date": "12/05/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 65 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/B5CCfTt2/sofa-10.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Inspired by Nordic design, this minimalist sofa brings timeless sophistication to any room..." }
	},
	{
		"postTitle": { "titleText": "Vintage Tufted Chesterfield Sofa" },
		"postId": { "id": 105 },
		"postDate": { "date": "12/05/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 199 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/sdWRcVFB/sofa-9.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Classic design meets modern comfort in this vintage-style Chesterfield, featuring deep button tufting and rolled arms..." }
	},
	{
		"postTitle": { "titleText": "Reclining Luxury Sofa with USB Ports" },
		"postId": { "id": 106 },
		"postDate": { "date": "12/05/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 134 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/7NvXfYsj/sofa-8.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Stay connected and relaxed with this reclining sofa that includes built-in USB ports and plush padding..." }
	},
	{
		"postTitle": { "titleText": "Eco-Friendly Rattan Sofa Set" },
		"postId": { "id": 107 },
		"postDate": { "date": "12/05/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 78 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/dsRcFX0D/sofa-5.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Go green with this sustainable rattan sofa, ideal for eco-conscious interiors and patios alike..." }
	},
	{
		"postTitle": { "titleText": "Convertible Sofa Bed for Guest Rooms" },
		"postId": { "id": 108 },
		"postDate": { "date": "12/05/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 111 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/kgfhmktL/sofa-7.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Maximize space with this multifunctional sofa bed — perfect for small apartments and guest rooms..." }
	},
	{
		"postTitle": { "titleText": "Customizable Modular Sofa Set" },
		"postId": { "id": 109 },
		"postDate": { "date": "12/05/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 90 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/pjYtvxwb/sofa-6.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Rearrange your comfort with this modular sofa system, offering endless combinations and layouts..." }
	},
	{
		"postTitle": { "titleText": "Compact Sofa for Small Living Spaces" },
		"postId": { "id": 110 },
		"postDate": { "date": "12/05/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 67 },
		"postThumbnail": { "srcUrl": "https://i.ibb.co/gbgf15Kx/sofa-4.png" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Ideal for apartments and studios, this compact sofa delivers style and comfort without taking up much room..." }
	}
]
